<template>
  <form @submit.prevent="onSubmit" class="height-100">
    <v-layout column justify-space-between fill-height>
      <!-- 폼 영역 시작 -->
      <v-flex>
        <p class="page-title">
          바이나우 이용 약관<br />
          동의가 필요합니다.
        </p>
        <div class="group-block py-5 mb-4">
          <v-checkbox
            v-model="agreeAll"
            hide-details
            class="mt-0 pt-0"
            @click="toggleAgreeAll(agreeAll)"
          >
            <template v-slot:label>
              <div class="font-weight-bold" :class="`color--gray-${agreeAll ? '100' : '70'}`">
                아래 내용에 모두 동의합니다.
              </div>
            </template>
          </v-checkbox>
        </div>

        <div class="px-5">
          <!-- 필수 약관 시작 -->
          <v-checkbox
            v-for="{ $model: terms } in $v.requiredTerms.$each.$iter"
            :key="terms.uuid"
            v-model="terms.isAgree"
            hide-details
            :label="`${terms.title} (필수)`"
            :disabled="loading"
            @click="checkAgreeAll"
          >
            <template v-slot:append>
              <router-link
                id="btn__5Jf9r+C+pEaDJWG+v6NuCA=="
                :to="{ path: `/terms/${terms.uuid}` }"
                target="_blank"
              >
                <v-icon class="color--gray-50">mdi-chevron-right</v-icon>
              </router-link>
            </template>
          </v-checkbox>
          <!-- 필수 약관 끝 -->

          <!-- 선택 약관 시작 -->
          <v-checkbox
            v-model="terms.isAgree"
            hide-details
            v-for="terms in optionalTerms"
            :label="`${terms.title} (선택)`"
            :key="terms.uuid"
            :disabled="loading"
            @click="checkAgreeAll"
          >
            <template v-slot:append>
              <router-link
                id="btn__7RUBk71L3EW3SezC2iSwVg=="
                :to="{ path: `/terms/${terms.uuid}` }"
                target="_blank"
              >
                <v-icon class="color--gray-50">mdi-chevron-right</v-icon>
              </router-link>
            </template>
          </v-checkbox>
          <!-- 선택 약관 끝 -->
        </div>
      </v-flex>

      <!-- 하단 영역 시작 -->
      <div class="page-footer-column">
        <BasicButton
          block
          large
          type="submit"
          height="52"
          :disabled="invalid || loading"
          :loading="loading"
          id="btn__L7hJHJEkcECDqT/JyN+WmQ"
        >
          다음
        </BasicButton>
      </div>
      <!-- 하단 영역 끝 -->
    </v-layout>
  </form>
</template>

<script>
import { sameAs } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import { simpleClone } from '@/util'

export default {
  props: ['loading'],
  data() {
    return {
      agreeAll: false,
    }
  },
  validations: {
    requiredTerms: {
      $each: {
        isAgree: {
          sameAs: sameAs(() => true),
        },
      },
    },
  },
  computed: {
    ...mapState('terms', ['termses']),
    invalid() {
      return this.$v.requiredTerms.$invalid
    },
    terms() {
      return simpleClone(this.termses).map((e) => {
        return { ...e, isAgree: false }
      })
    },
    requiredTerms() {
      return this.terms.filter((e) => e.isRequired === true)
    },
    optionalTerms() {
      return this.terms.filter((e) => e.isRequired !== true)
    },
  },
  methods: {
    checkAgreeAll() {
      // 전체 체크면 체크 - 전체 해제면 해제
      if (this.terms.every((e) => e.isAgree === true)) {
        this.agreeAll = true
        return
      }
      this.agreeAll = false
    },
    toggleAgreeAll(flag) {
      for (const term of this.terms) {
        term.isAgree = flag
      }
    },
    onSubmit() {
      if (this.invalid) reutrn
      this.$emit('next', simpleClone(this.terms))
    },
  },
}
</script>
